
(function() {
  function setupZaraZoom() {
    const container = document.querySelector('.product__media-container.has-nude-zoom');
    if (!container) return;

    let modal = document.getElementById('flCustomZoomModal');
    if (!modal) return;

    // Modal ko screen ke root body me move karein
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const zoomBody = modal.querySelector('.fl-zoom-body');
    const sidebar = modal.querySelector('.fl-zoom-sidebar');
    const items = Array.from(container.querySelectorAll('.product-media-item'));
    const nativeZoomBtn = container.querySelector('.product__media-action-button');

    // 404 error fix karne ke liye safe high-res image URL extractor
    function getCleanHighRes(url) {
      if (!url) return '';
      // _1024x1024 ya _1024x ko hata kar original full-size image uthayega
      return url.replace(/_(?:1024x1024|1024x|800x|600x)(?=\.[a-zA-Z]+(\?|$))/, '');
    }

    function extractMediaList() {
      const list = [];
      items.forEach((item) => {
        const img = item.querySelector('img:not([style*="display: none"])');
        const video = item.querySelector('video');

        if (img) {
          const rawSrc = img.currentSrc || img.src || img.getAttribute('data-src') || '';
          const highRes = getCleanHighRes(rawSrc);
          list.push({ type: 'image', src: highRes, thumb: rawSrc });
        } else if (video) {
          const source = video.querySelector('source[type="video/mp4"]') || video.querySelector('source');
          list.push({
            type: 'video',
            src: source ? source.src : '',
            thumb: video.getAttribute('poster') || ''
          });
        }
      });
      return list;
    }

    const mediaList = extractMediaList();

    function renderActiveMedia(index) {
      const media = mediaList[index];
      if (!media || !zoomBody) return;

      if (media.type === 'image') {
        zoomBody.innerHTML = `<img src="${media.src}" alt="Zoom view" style="display:block; width:100% !important; height:auto">`;
      } else if (media.type === 'video') {
        zoomBody.innerHTML = `
          <video playsinline muted loop autoplay controls poster="${media.thumb}" style="display:block; width:100% !important; height:auto;">
            <source src="${media.src}" type="video/mp4">
          </video>`;
      }

      if (sidebar) {
        const thumbs = sidebar.querySelectorAll('img');
        thumbs.forEach(t => t.classList.remove('active'));
        if (thumbs[index]) thumbs[index].classList.add('active');
      }

      modal.scrollTop = 0;
    }

    function buildSidebar(activeIndex) {
      if (!sidebar) return;
      sidebar.innerHTML = '';
      mediaList.forEach((media, idx) => {
        const t = document.createElement('img');
        t.src = media.thumb;
        if (idx === activeIndex) t.classList.add('active');

        t.onclick = function(e) {
          e.stopPropagation();
          renderActiveMedia(idx);
        };
        sidebar.appendChild(t);
      });
    }

    // Modal Open Function
    window.openZaraGallery = function(index = 0) {
      buildSidebar(index);
      renderActiveMedia(index);
      
      // Inline styles taake koi CSS isay chupaa na sake
      modal.style.setProperty('display', 'block', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      modal.style.setProperty('opacity', '1', 'important');
      document.body.style.overflow = 'hidden';
    };

    // Modal Close Function
    window.closeCustomZoom = function() {
      modal.style.setProperty('display', 'none', 'important');
      if (zoomBody) zoomBody.innerHTML = '';
      document.body.style.overflow = '';
    };

    // Click events attach karna
    items.forEach((item, index) => {
      item.style.cursor = 'zoom-in';
      item.addEventListener('click', function(e) {
        if (e.target.closest('.badge') || e.target.closest('.flickity-button')) return;
        e.preventDefault();
        e.stopPropagation();
        window.openZaraGallery(index);
      }, true);
    });

    if (nativeZoomBtn) {
      nativeZoomBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.openZaraGallery(0);
      }, true);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display === 'block') {
        window.closeCustomZoom();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupZaraZoom);
  } else {
    setupZaraZoom();
  }

  document.addEventListener('shopify:section:load', setupZaraZoom);
})();